import React from 'react';
import { bool, func, string } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const ShareModalDrawer = ({ showSuccessIcon, onClick, imgLink, title }) => {
  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.shareDrawer}>
        <div className={styles.shareImageContainer}>
          <img className={styles.icon} src={imgLink} alt={title} />
        </div>
        <div className={styles.title}>{title}</div>
        {showSuccessIcon && (
          <img
            src="https://cdn-assets.alltrails.com/assets/icons/share/filled@2x.png"
            alt={StringConstantsMixin.strings.SUCCESS}
            className={styles.successImage}
          />
        )}
      </div>
    </div>
  );
};

ShareModalDrawer.propTypes = {
  showSuccessIcon: bool,
  onClick: func,
  imgLink: string,
  title: string
};

ShareModalDrawer.defaultProps = {
  showSuccessIcon: false,
  onClick: () => {},
  imgLink: '',
  title: ''
};

export default ShareModalDrawer;
